import clsx from 'clsx';
import React from 'react';

import { Newsletter } from '@hooks/useCurrentNewsletter';

import NewsletterSignUp from '../NewsletterSignup';
import styles from './headerStyle.module.scss';

interface HeaderProps {
  currentUserAccessLevel: number;
  isLoggedIn: boolean;
  isSubscribed: boolean;
  gdprColorScheme: string;
  gdpr: boolean;
  newsletter: Newsletter;
}

const Header = ({
  currentUserAccessLevel,
  isLoggedIn,
  isSubscribed,
  gdprColorScheme,
  gdpr,
  newsletter,
}: HeaderProps) => {
  return (
    <div className={styles.mainContainer} id="feed-newsletter-container-header">
      <div className={clsx(styles.headerContainer, 'container')}>
        <div className={styles.headerWrapper}>
          <div className={styles.newsletterIntro}>
            <div className={styles.title}>Newsletter</div>
            <h1 className={styles.newsletterName}>{newsletter.name}</h1>
            <div className={styles.newsletterAuthor}>by {newsletter.author.name}</div>
            <div className={styles.newsletterLandingPageDescription}>
              {newsletter.landingPageDescription}
            </div>
          </div>
          <div className={styles.newsletterAction}>
            <NewsletterSignUp
              currentUserAccessLevel={currentUserAccessLevel}
              isLoggedIn={isLoggedIn}
              isSubscribed={isSubscribed}
              gdpr={gdpr}
              gdprColorScheme={gdprColorScheme}
              newsletter={newsletter}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
